export const onTecRelationshipTypeChangeHandler = (
  teamMemberTecRelationshipType,
  filters,
  filtersUpdater
) => {
  let updatedFilters = {};

  filtersUpdater(prevFilters => {
    updatedFilters = {
      ...prevFilters,
      teamMemberTecRelationshipType
    };
    return updatedFilters;
  });

  return updatedFilters;
};